import * as classNames from 'classnames'
import * as React from 'react'

import categories from '../../../../config/sites/categories'
import Button from '../../../components/button'
import ItemPreviewer from '../../../components/itemPreviewer'
import ItemThumbnailCarousel from '../itemThumbnailCarousel'
import PageSection from '../pageSection'
import SectionDescription from '../sectionDescription'

import { IItem } from '../../../../typings/searchResults'
import { ISeoItem } from '../../../../typings/seoMetadata'

import * as styles from './featuredItemsSection.module.css'

const FeaturedItemsSection = ({
  items,
  metadata,
  videoMuted,
  muteVideo
}: {
  items: IItem[]
  metadata: ISeoItem
  videoMuted: boolean
  muteVideo: () => any
}) => {
  return (
    <div className={styles.section} data-test-selector="featuredItemSection">
      <SectionDescription metadata={metadata} HTag="h4" />
      <PageSection>
        <ItemThumbnailCarousel>
          {items.map(item => {
            return (
              <ItemPreviewer
                item={item}
                key={item.id}
                videoMuted={videoMuted}
                muteVideo={muteVideo}
              />
            )
          })}
        </ItemThumbnailCarousel>
        <div
          className={styles.buttonSection}
          data-test-selector="featuredItemButtonSection"
        >
          <Button primary href="/feature">
            View More Featured Items
          </Button>
        </div>
      </PageSection>
    </div>
  )
}

export default FeaturedItemsSection



// WEBPACK FOOTER //
// ./client/pages/home/featuredItemsSection/featuredItemsSection.tsx